import {
  Companion_getInstancem5ekhykter02 as Companion_getInstance,
  CrowPayAlertxsn5n3sp58h5 as CrowPayAlert,
  AlertCategory_Info_getInstance3jt06v3o3bnmb as AlertCategory_Info_getInstance,
  AlertCategory2i9ic5ekxmxrh as AlertCategory,
  EmailData2csvvu2p1bk3b as EmailData,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function get_read(_this__u8e3s4) {
  return _this__u8e3s4.prop(CrowPayAlert_read_getInstance());
}
function prepareCrowPayAlertFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [CrowPayAlert_title_getInstance(), CrowPayAlert_body_getInstance(), CrowPayAlert_category_getInstance(), CrowPayAlert_isReminder_getInstance(), CrowPayAlert_read_getInstance(), CrowPayAlert_url_getInstance(), CrowPayAlert_email_getInstance(), CrowPayAlert_project_getInstance()];
  var tmp = Companion_getInstance().m2a();
  properties(tmp, (it) => props);
}
function CrowPayAlert_read$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(4);
}
function CrowPayAlert_read$_get_name_$ref_6np9ft() {
  return (p0) => p0.k20();
}
function CrowPayAlert_read$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[4];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayAlert_read$_get_serializer_$ref_cbeqzm() {
  return (p0) => p0.j2j();
}
function CrowPayAlert_read$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(4);
}
function CrowPayAlert_read$_get_annotations_$ref_akfw9u() {
  return (p0) => p0.bz();
}
var CrowPayAlert_readClass;
function CrowPayAlert_read() {
  if (CrowPayAlert_readClass === VOID) {
    class $ {
      constructor() {
        CrowPayAlert_read_instance = this;
        var tmp = this;
        tmp.t5s_1 = lazy(CrowPayAlert_read$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.u5s_1 = lazy(CrowPayAlert_read$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.v5s_1 = lazy(CrowPayAlert_read$annotations$delegate$lambda);
        this.w5s_1 = false;
        this.x5s_1 = 'false';
      }
      k20() {
        var tmp0 = this.t5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayAlert_read$_get_name_$ref_6np9ft(), null);
        return tmp0.f2();
      }
      y5s(receiver) {
        return receiver.d5t_1;
      }
      m2j(receiver) {
        return this.y5s(receiver instanceof CrowPayAlert() ? receiver : THROW_CCE());
      }
      h5t(receiver, value) {
        return receiver.i5t(VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CrowPayAlert() ? receiver : THROW_CCE();
        return this.h5t(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.u5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayAlert_read$_get_serializer_$ref_cbeqzm(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.v5s_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayAlert_read$_get_annotations_$ref_akfw9u(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayAlert_read', VOID, VOID, [SerializableProperty()]);
    CrowPayAlert_readClass = $;
  }
  return CrowPayAlert_readClass;
}
var CrowPayAlert_read_instance;
function CrowPayAlert_read_getInstance() {
  if (CrowPayAlert_read_instance === VOID)
    new (CrowPayAlert_read())();
  return CrowPayAlert_read_instance;
}
function CrowPayAlert_title$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(0);
}
function CrowPayAlert_title$_get_name_$ref_euu2b3() {
  return (p0) => p0.k20();
}
function CrowPayAlert_title$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayAlert_title$_get_serializer_$ref_ee50p4() {
  return (p0) => p0.j2j();
}
function CrowPayAlert_title$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(0);
}
function CrowPayAlert_title$_get_annotations_$ref_3vy798() {
  return (p0) => p0.bz();
}
var CrowPayAlert_titleClass;
function CrowPayAlert_title() {
  if (CrowPayAlert_titleClass === VOID) {
    class $ {
      constructor() {
        CrowPayAlert_title_instance = this;
        var tmp = this;
        tmp.j5t_1 = lazy(CrowPayAlert_title$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.k5t_1 = lazy(CrowPayAlert_title$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.l5t_1 = lazy(CrowPayAlert_title$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.j5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayAlert_title$_get_name_$ref_euu2b3(), null);
        return tmp0.f2();
      }
      y5s(receiver) {
        return receiver.z5s_1;
      }
      m2j(receiver) {
        return this.y5s(receiver instanceof CrowPayAlert() ? receiver : THROW_CCE());
      }
      m5t(receiver, value) {
        return receiver.i5t(value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CrowPayAlert() ? receiver : THROW_CCE();
        return this.m5t(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.k5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayAlert_title$_get_serializer_$ref_ee50p4(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.l5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayAlert_title$_get_annotations_$ref_3vy798(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayAlert_title', VOID, VOID, [SerializableProperty()]);
    CrowPayAlert_titleClass = $;
  }
  return CrowPayAlert_titleClass;
}
var CrowPayAlert_title_instance;
function CrowPayAlert_title_getInstance() {
  if (CrowPayAlert_title_instance === VOID)
    new (CrowPayAlert_title())();
  return CrowPayAlert_title_instance;
}
function CrowPayAlert_body$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(1);
}
function CrowPayAlert_body$_get_name_$ref_q2yzct() {
  return (p0) => p0.k20();
}
function CrowPayAlert_body$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayAlert_body$_get_serializer_$ref_o56bmy() {
  return (p0) => p0.j2j();
}
function CrowPayAlert_body$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(1);
}
function CrowPayAlert_body$_get_annotations_$ref_gs3ige() {
  return (p0) => p0.bz();
}
var CrowPayAlert_bodyClass;
function CrowPayAlert_body() {
  if (CrowPayAlert_bodyClass === VOID) {
    class $ {
      constructor() {
        CrowPayAlert_body_instance = this;
        var tmp = this;
        tmp.n5t_1 = lazy(CrowPayAlert_body$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o5t_1 = lazy(CrowPayAlert_body$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p5t_1 = lazy(CrowPayAlert_body$annotations$delegate$lambda);
      }
      k20() {
        var tmp0 = this.n5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayAlert_body$_get_name_$ref_q2yzct(), null);
        return tmp0.f2();
      }
      y5s(receiver) {
        return receiver.a5t_1;
      }
      m2j(receiver) {
        return this.y5s(receiver instanceof CrowPayAlert() ? receiver : THROW_CCE());
      }
      m5t(receiver, value) {
        return receiver.i5t(VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CrowPayAlert() ? receiver : THROW_CCE();
        return this.m5t(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayAlert_body$_get_serializer_$ref_o56bmy(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayAlert_body$_get_annotations_$ref_gs3ige(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayAlert_body', VOID, VOID, [SerializableProperty()]);
    CrowPayAlert_bodyClass = $;
  }
  return CrowPayAlert_bodyClass;
}
var CrowPayAlert_body_instance;
function CrowPayAlert_body_getInstance() {
  if (CrowPayAlert_body_instance === VOID)
    new (CrowPayAlert_body())();
  return CrowPayAlert_body_instance;
}
function CrowPayAlert_category$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(2);
}
function CrowPayAlert_category$_get_name_$ref_z7ekyp() {
  return (p0) => p0.k20();
}
function CrowPayAlert_category$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayAlert_category$_get_serializer_$ref_nz2e2i() {
  return (p0) => p0.j2j();
}
function CrowPayAlert_category$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(2);
}
function CrowPayAlert_category$_get_annotations_$ref_gs8hvu() {
  return (p0) => p0.bz();
}
var CrowPayAlert_categoryClass;
function CrowPayAlert_category() {
  if (CrowPayAlert_categoryClass === VOID) {
    class $ {
      constructor() {
        CrowPayAlert_category_instance = this;
        var tmp = this;
        tmp.q5t_1 = lazy(CrowPayAlert_category$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.r5t_1 = lazy(CrowPayAlert_category$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.s5t_1 = lazy(CrowPayAlert_category$annotations$delegate$lambda);
        this.t5t_1 = AlertCategory_Info_getInstance();
        this.u5t_1 = 'AlertCategory.Info';
      }
      k20() {
        var tmp0 = this.q5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayAlert_category$_get_name_$ref_z7ekyp(), null);
        return tmp0.f2();
      }
      y5s(receiver) {
        return receiver.b5t_1;
      }
      m2j(receiver) {
        return this.y5s(receiver instanceof CrowPayAlert() ? receiver : THROW_CCE());
      }
      v5t(receiver, value) {
        return receiver.i5t(VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CrowPayAlert() ? receiver : THROW_CCE();
        return this.v5t(tmp, value instanceof AlertCategory() ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.r5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayAlert_category$_get_serializer_$ref_nz2e2i(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.s5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayAlert_category$_get_annotations_$ref_gs8hvu(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayAlert_category', VOID, VOID, [SerializableProperty()]);
    CrowPayAlert_categoryClass = $;
  }
  return CrowPayAlert_categoryClass;
}
var CrowPayAlert_category_instance;
function CrowPayAlert_category_getInstance() {
  if (CrowPayAlert_category_instance === VOID)
    new (CrowPayAlert_category())();
  return CrowPayAlert_category_instance;
}
function CrowPayAlert_isReminder$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(3);
}
function CrowPayAlert_isReminder$_get_name_$ref_l7t78d() {
  return (p0) => p0.k20();
}
function CrowPayAlert_isReminder$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayAlert_isReminder$_get_serializer_$ref_2mdh8() {
  return (p0) => p0.j2j();
}
function CrowPayAlert_isReminder$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(3);
}
function CrowPayAlert_isReminder$_get_annotations_$ref_dufgoo() {
  return (p0) => p0.bz();
}
var CrowPayAlert_isReminderClass;
function CrowPayAlert_isReminder() {
  if (CrowPayAlert_isReminderClass === VOID) {
    class $ {
      constructor() {
        CrowPayAlert_isReminder_instance = this;
        var tmp = this;
        tmp.w5t_1 = lazy(CrowPayAlert_isReminder$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x5t_1 = lazy(CrowPayAlert_isReminder$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y5t_1 = lazy(CrowPayAlert_isReminder$annotations$delegate$lambda);
        this.z5t_1 = false;
        this.a5u_1 = 'false';
      }
      k20() {
        var tmp0 = this.w5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayAlert_isReminder$_get_name_$ref_l7t78d(), null);
        return tmp0.f2();
      }
      y5s(receiver) {
        return receiver.c5t_1;
      }
      m2j(receiver) {
        return this.y5s(receiver instanceof CrowPayAlert() ? receiver : THROW_CCE());
      }
      h5t(receiver, value) {
        return receiver.i5t(VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CrowPayAlert() ? receiver : THROW_CCE();
        return this.h5t(tmp, (!(value == null) ? typeof value === 'boolean' : false) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.x5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayAlert_isReminder$_get_serializer_$ref_2mdh8(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y5t_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayAlert_isReminder$_get_annotations_$ref_dufgoo(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayAlert_isReminder', VOID, VOID, [SerializableProperty()]);
    CrowPayAlert_isReminderClass = $;
  }
  return CrowPayAlert_isReminderClass;
}
var CrowPayAlert_isReminder_instance;
function CrowPayAlert_isReminder_getInstance() {
  if (CrowPayAlert_isReminder_instance === VOID)
    new (CrowPayAlert_isReminder())();
  return CrowPayAlert_isReminder_instance;
}
function CrowPayAlert_url$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(5);
}
function CrowPayAlert_url$_get_name_$ref_aomq7s() {
  return (p0) => p0.k20();
}
function CrowPayAlert_url$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[5];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayAlert_url$_get_serializer_$ref_uwx23z() {
  return (p0) => p0.j2j();
}
function CrowPayAlert_url$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(5);
}
function CrowPayAlert_url$_get_annotations_$ref_jzevpv() {
  return (p0) => p0.bz();
}
var CrowPayAlert_urlClass;
function CrowPayAlert_url() {
  if (CrowPayAlert_urlClass === VOID) {
    class $ {
      constructor() {
        CrowPayAlert_url_instance = this;
        var tmp = this;
        tmp.b5u_1 = lazy(CrowPayAlert_url$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.c5u_1 = lazy(CrowPayAlert_url$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.d5u_1 = lazy(CrowPayAlert_url$annotations$delegate$lambda);
        this.e5u_1 = null;
        this.f5u_1 = 'null';
      }
      k20() {
        var tmp0 = this.b5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayAlert_url$_get_name_$ref_aomq7s(), null);
        return tmp0.f2();
      }
      y5s(receiver) {
        return receiver.e5t_1;
      }
      m2j(receiver) {
        return this.y5s(receiver instanceof CrowPayAlert() ? receiver : THROW_CCE());
      }
      g5u(receiver, value) {
        return receiver.i5t(VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CrowPayAlert() ? receiver : THROW_CCE();
        return this.g5u(tmp, (value == null ? true : typeof value === 'string') ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.c5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayAlert_url$_get_serializer_$ref_uwx23z(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.d5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayAlert_url$_get_annotations_$ref_jzevpv(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayAlert_url', VOID, VOID, [SerializableProperty()]);
    CrowPayAlert_urlClass = $;
  }
  return CrowPayAlert_urlClass;
}
var CrowPayAlert_url_instance;
function CrowPayAlert_url_getInstance() {
  if (CrowPayAlert_url_instance === VOID)
    new (CrowPayAlert_url())();
  return CrowPayAlert_url_instance;
}
function CrowPayAlert_email$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(6);
}
function CrowPayAlert_email$_get_name_$ref_ydjkh7() {
  return (p0) => p0.k20();
}
function CrowPayAlert_email$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[6];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayAlert_email$_get_serializer_$ref_itrjt0() {
  return (p0) => p0.j2j();
}
function CrowPayAlert_email$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(6);
}
function CrowPayAlert_email$_get_annotations_$ref_pvgcg() {
  return (p0) => p0.bz();
}
var CrowPayAlert_emailClass;
function CrowPayAlert_email() {
  if (CrowPayAlert_emailClass === VOID) {
    class $ {
      constructor() {
        CrowPayAlert_email_instance = this;
        var tmp = this;
        tmp.h5u_1 = lazy(CrowPayAlert_email$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.i5u_1 = lazy(CrowPayAlert_email$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.j5u_1 = lazy(CrowPayAlert_email$annotations$delegate$lambda);
        this.k5u_1 = null;
        this.l5u_1 = 'null';
      }
      k20() {
        var tmp0 = this.h5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayAlert_email$_get_name_$ref_ydjkh7(), null);
        return tmp0.f2();
      }
      y5s(receiver) {
        return receiver.f5t_1;
      }
      m2j(receiver) {
        return this.y5s(receiver instanceof CrowPayAlert() ? receiver : THROW_CCE());
      }
      m5u(receiver, value) {
        return receiver.i5t(VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CrowPayAlert() ? receiver : THROW_CCE();
        return this.m5u(tmp, (value == null ? true : value instanceof EmailData()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.i5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayAlert_email$_get_serializer_$ref_itrjt0(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.j5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayAlert_email$_get_annotations_$ref_pvgcg(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayAlert_email', VOID, VOID, [SerializableProperty()]);
    CrowPayAlert_emailClass = $;
  }
  return CrowPayAlert_emailClass;
}
var CrowPayAlert_email_instance;
function CrowPayAlert_email_getInstance() {
  if (CrowPayAlert_email_instance === VOID)
    new (CrowPayAlert_email())();
  return CrowPayAlert_email_instance;
}
function CrowPayAlert_project$name$delegate$lambda() {
  return Companion_getInstance().m2a().az().v11(7);
}
function CrowPayAlert_project$_get_name_$ref_h5wdhq() {
  return (p0) => p0.k20();
}
function CrowPayAlert_project$serializer$delegate$lambda() {
  var tmp = Companion_getInstance().m2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).t1b()[7];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function CrowPayAlert_project$_get_serializer_$ref_tfejl3() {
  return (p0) => p0.j2j();
}
function CrowPayAlert_project$annotations$delegate$lambda() {
  return Companion_getInstance().m2a().az().x11(7);
}
function CrowPayAlert_project$_get_annotations_$ref_r8mx1f() {
  return (p0) => p0.bz();
}
var CrowPayAlert_projectClass;
function CrowPayAlert_project() {
  if (CrowPayAlert_projectClass === VOID) {
    class $ {
      constructor() {
        CrowPayAlert_project_instance = this;
        var tmp = this;
        tmp.n5u_1 = lazy(CrowPayAlert_project$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.o5u_1 = lazy(CrowPayAlert_project$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.p5u_1 = lazy(CrowPayAlert_project$annotations$delegate$lambda);
        this.q5u_1 = null;
        this.r5u_1 = 'null';
      }
      k20() {
        var tmp0 = this.n5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, CrowPayAlert_project$_get_name_$ref_h5wdhq(), null);
        return tmp0.f2();
      }
      y5s(receiver) {
        return receiver.g5t_1;
      }
      m2j(receiver) {
        return this.y5s(receiver instanceof CrowPayAlert() ? receiver : THROW_CCE());
      }
      s5u(receiver, value) {
        return receiver.i5t(VOID, VOID, VOID, VOID, VOID, VOID, VOID, value);
      }
      p2j(receiver, value) {
        var tmp = receiver instanceof CrowPayAlert() ? receiver : THROW_CCE();
        return this.s5u(tmp, (value == null ? true : value instanceof UUID()) ? value : THROW_CCE());
      }
      j2j() {
        var tmp0 = this.o5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, CrowPayAlert_project$_get_serializer_$ref_tfejl3(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.p5u_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, CrowPayAlert_project$_get_annotations_$ref_r8mx1f(), null);
        return tmp0.f2();
      }
    }
    protoOf($).q2j = get_serializableAnnotations;
    initMetadataForObject($, 'CrowPayAlert_project', VOID, VOID, [SerializableProperty()]);
    CrowPayAlert_projectClass = $;
  }
  return CrowPayAlert_projectClass;
}
var CrowPayAlert_project_instance;
function CrowPayAlert_project_getInstance() {
  if (CrowPayAlert_project_instance === VOID)
    new (CrowPayAlert_project())();
  return CrowPayAlert_project_instance;
}
//region block: exports
export {
  prepareCrowPayAlertFields as prepareCrowPayAlertFields2zbi6walp1njt,
  get_read as get_read10m44ajihqkgu,
};
//endregion

//# sourceMappingURL=CrowPayAlertFields.mjs.map
